export const GET_OCCUPATIONS = '[OCCUPATIONS] GET OCCUPATIONS';

export const OCCUPATIONS_INITIATE = '[OCCUPATIONS] INITIATE';
export const CHANGE_ERROR_MESSAGE = '[OCCUPATIONS] CHANGE ERROR MESSAGE';
